import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useRef, useEffect, useCallback } from 'react';

dayjs.extend(utc);
dayjs.extend(timezone);

const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const useTimezoneConverter = (timezone: string | null) => {
    const timezoneRef = useRef<string | null>(timezone);

    useEffect(() => {
        timezoneRef.current = timezone;
    }, [timezone]);

    const formatUtcToStoreTime = useCallback((utcTime?: string | null) => {
        if (!utcTime || !timezoneRef.current) {
            return '-';
        }

        return dayjs.utc(utcTime).tz(timezoneRef.current).format(DATE_TIME_FORMAT);
    }, []);

    const storeWallTimeToUtcTimestamp = useCallback((value?: dayjs.Dayjs | null) => {
        if (!value || !timezoneRef.current) {
            return null;
        }

        return dayjs.tz(value.format(DATE_TIME_FORMAT), timezoneRef.current).valueOf();
    }, []);

    const storeWallTimeToUtcString = useCallback((value?: dayjs.Dayjs | null) => {
        if (!value || !timezoneRef.current) {
            return '';
        }

        return dayjs.tz(value.format(DATE_TIME_FORMAT), timezoneRef.current).utc().format(DATE_TIME_FORMAT);
    }, []);

    return {
        timezoneRef,
        isTimezoneReady: Boolean(timezone),
        formatUtcToStoreTime,
        storeWallTimeToUtcTimestamp,
        storeWallTimeToUtcString,
    };
};
